<template>
	<v-card flat color="transparent">	
		<NavigationItem 
	
			name="Meeting Room"
			:iconcolor="iconColor"
			:badge="badge"
			description="Konferenzmodul für Echtzeitkommunikation "
			type="click"
			:icon="icon"
			:tooltip="false"
			@click="startVideo"
		>
		</NavigationItem>
	</v-card>
</template>

<style lang="less">
	.chat-window{
		position: inherit;
	}
</style>

<script>
// import Vue from "vue"
	import Vuex from "vuex";
	import NavigationItem from "@/components/elements/NavigationItem"
	export default {
		name: "MeetingRoomButton",
		data: () => {
			return {
			}
		},
		components: {
			NavigationItem
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				users: state => state.users,
				groups: state => state.groups || []
			}),
			liveGroups(){
				return this.groups.filter( g => g.video_enabled) 
			},
			active(){
				return this.liveGroups.length;
			},
			badge(){
				if( this.active ){
					return 1
				}
				return false;
			},
			icon(){
				return this.active ? "mdi-television" : "mdi-television-off" 
			},
			iconColor(){
				return this.active ? "green" : "grey" 
			}
		},
		methods: {
			startVideo(){
			}
		}
	}
</script>